import { useEffect, useContext, useState, useRef } from "react";
import { FileDrop } from "react-file-drop";
import { ReadFile } from "../../lib/vectorFileEngine";
import { addFeatureIdToGeoJSONProperties } from "../../lib/featureUtils";
import { trans } from "../../lib/utils";

function FileUploadComponent(props) {
  const [placeholder, setPlaceholder] = useState(
    "Allowed files: KML, Shapefile (Zip), DXF, GeoJSON"
  );

  const [allowedExtensions, setAllowedExtensions] = useState([
    "dxf",
    "zip",
    "kml",
    "json",
  ]);

  useEffect(() => {
    if (props.placeholder) {
      setPlaceholder(props.placeholder);
    }
    if (props.allowedExtensions) {
      setAllowedExtensions(props.allowedExtensions);
    }
  }, []);

  const { onDropFeatures } = props;

  const fileInputRef = useRef(null);

  const onFileInputChange = (event) => {
    const { files } = event.target;

    if (Array.from(files).length > 1) {
      return;
    }

    Array.from(files).forEach(async (file) => {
      const ext = file.name.split(".").pop().toLowerCase();

      if (allowedExtensions.indexOf(ext) < 0) {
        return;
      }

      let geoJson = await ReadFile(file);

      if (ext !== "zip") {
        geoJson = addFeatureIdToGeoJSONProperties(geoJson, "EPSG:4326");
      } else {
        geoJson = addFeatureIdToGeoJSONProperties(geoJson);
      }
      if (onDropFeatures) {
        onDropFeatures(geoJson, ext, file.name);
      }
    });
  };

  const onTargetClick = () => {
    fileInputRef.current.click();
  };

  return (
    <div>
      <FileDrop
        onFrameDragEnter={(event) => {}}
        onFrameDragLeave={(event) => {}}
        onTargetClick={onTargetClick}
        onFrameDrop={(event) => {}}
        onDragOver={(event) => {}}
        onDragLeave={(event) => {}}
        onDrop={(files, event) => {
          if (Array.from(files).length > 1) {
            return;
          }

          Array.from(files).forEach(async (file) => {
            const ext = file.name.split(".").pop().toLowerCase();

            if (allowedExtensions.indexOf(ext) < 0) {
              return;
            }

            let geoJson = await ReadFile(file);

            if (ext !== "zip") {
              geoJson = addFeatureIdToGeoJSONProperties(geoJson, "EPSG:4326");
            } else {
              geoJson = addFeatureIdToGeoJSONProperties(geoJson);
            }
            if (onDropFeatures) {
              onDropFeatures(geoJson, ext, file.name);
            }
          });
        }}
      >
        <div className="w-100 text-center p-4 border">
          <span className="d-block mb-1">
            <strong>
              <span className="color-purple" role="button" onClick={() => {}}>
                {trans("Click here to upload")}
              </span>{" "}
              {trans("or drag and drop")}
            </strong>
          </span>
          <span className="color-grey d-block">{placeholder}</span>
        </div>
      </FileDrop>
      <input
        onChange={onFileInputChange}
        ref={fileInputRef}
        type="file"
        style={{ display: "none" }}
      />
    </div>
  );
}
export default FileUploadComponent;
